import CustomersView from '@/views/app/customers/customers-view'
import CustomersContentView from '@/views/app/customers/customers-content-view'
import CustomersTableTask from '@/modules/customers/customers-task-table'
import CustomersTableOpportunity from '@/modules/customers/customers-opportunity-table'
import CustomersCardNotes from '@/modules/customers/customers-notes-cards'
import CustomersTableTractors from '@/modules/customers/customers-tractors-table'
import CustomersInfo from '@/modules/customers/customers-info'
import CustomersGuards from '@/guards/customers.guards'

export default [
  {
    path: 'customers',
    component: CustomersView,
    children: [
      {
        path: '',
        name: 'customers',
        redirect: (to) => {
          return { name: 'customers-info' }
        }
      },
      {
        path: ':id?',
        component: CustomersContentView,
        children: [
          {
            path: 'info',
            name: 'customers-info',
            component: CustomersInfo,
            beforeEnter: CustomersGuards.onGetCustomer
          },
          {
            path: 'tasks',
            name: 'customers-task-table',
            component: CustomersTableTask,
            beforeEnter: CustomersGuards.onGetList('tasks')
          },
          {
            path: 'opportunities',
            name: 'customers-opportunity-table',
            component: CustomersTableOpportunity,
            beforeEnter: CustomersGuards.onGetList('opportunities')
          },
          {
            path: 'notes',
            name: 'customers-notes-cards',
            component: CustomersCardNotes,
            beforeEnter: CustomersGuards.onGetList('notes')
          },
          {
            path: 'tractors',
            name: 'customers-tractors-table',
            component: CustomersTableTractors,
            beforeEnter: CustomersGuards.onGetList('machineries')
          }
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/app/customers/index.js